// extracted by extract-css-chunks-webpack-plugin
module.exports = {"message-form":"message-form___KbAJ9","row":"row___2ZPSr","full":"full___2rN62","half":"half___3TyI2"};